export const en = {
    'header-caption-cpc': 'Use the keyword selection tool to add keywords and negative keywords for an ad group',
    'header-caption-cpm': 'Use the keyword selection tool to add keywords for an ad group',
    'header-title': 'Keyword planner',
    'help-link': 'learn more about keyword selection'
};
